import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormBuilder,
  UntypedFormGroup,
} from '@angular/forms';
import { UtilsService } from '@app/providers/utils/utils.service';

@Injectable({
  providedIn: 'root',
})
export class EaAssetsFormService {
  constructor(
    protected formBuilder: UntypedFormBuilder,
    protected utilsService: UtilsService,
  ) {}

  public generate(entity: any) {
    let options: AbstractControlOptions = {};
    if (!entity) entity = {};
    return this.formBuilder.group({}, options);
  }

  public extract(form: UntypedFormGroup, nestedForms?) {
    let dto = {};
    return dto;
  }
}
